import { getOnpremHostname } from 'omni-package-react-core';
import { getIdpTenantUrl } from './getIdpTenantUrl';

export default function closeCurrentSession({ backgroundLogOff = false }: { backgroundLogOff?: boolean } = {}) {
  sessionStorage.clear();
  const url = `${getIdpTenantUrl()}login/signout?fromURI=${getOnpremHostname()}/EEMWPNP1/logoffonpremise`;

  if (backgroundLogOff) {
    return fetch(url, {
      credentials: 'include',
      mode: 'no-cors',
    });
  }

  return window.location.replace(url);
}
